import React from "react";
import FinDocListPage from "../components/FinDocListPage";
import { queryFinDoc } from "../newApi/findoc.api";

export default function FinDocPendingAudit() {
  return (
    <FinDocListPage
      title="待審核"
      menuKey="FinDocPendingAudit"
      defaultStatuses={["pendingAudit", "pendingMgr"]}
      fetcher={queryFinDoc}
      extraFilters={(actor) => ({ next_auditor_mail: actor.email })}
      getActions={(record, actor, navigate) => [
        {
          label: "簽核",
          onClick: () => navigate(`/FinDoc/Audit/${record.findoc_no}`),
        },
      ]}
    />
  );
}